import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-category-parent',
  imports: [RouterLink,RouterOutlet, RouterLinkActive],
  templateUrl: './category-parent.component.html',
  styleUrl: './category-parent.component.css'
})
export class CategoryParentComponent {

}
